 <template>
  <section id="projects">
    <div name="fadeDown" :duration="1">
		<Title
		class="title"
		:title="$t('projects.title')"
    :description="$t('projects.description')"
		/>
    </div>

    <div class="container-fluid center-block">
      <article class="content text-center">
    
		    <div class="timeline mx-auto" v-for="(post, index) in translatedProjects" :key="index" name="fadeLeft" :duration="0.5">
			    <vue-timeline-update
            :date="post.date"
            :title="post.title"
            :description="post.content"
            :thumbnail="post.thumbnails"
            :color="post.color"
            :category="post.tag"
            :icon="post.icon"
          />
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Title from "./Title.vue";
import VueTimelineUpdate from './VueTimeLineUpdate.vue'

export default {
  name: "Projects",
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ({
        items: [
          {
            thumbnails: [
              "italian-01.jpg",
              "italian-02.jpg",
              "italian-03.jpg",
              "italian-04.jpg",
              "italian-05.jpg",
              "italian-06.jpg"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "buffet-01.jpg",
              "buffet-02.jpg",
              "buffet-03.jpg",
              "buffet-04.jpg",
              "buffet-05.jpg",
              "buffet-06.jpg"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "snack-01.jpg",
              "snack-02.jpg",
              "snack-03.jpg",
              "snack-04.jpg",
              "snack-05.jpg",
              "snack-06.jpg"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "beauty-01.jpg",
              "beauty-02.jpg",
              "beauty-03.jpg",
              "beauty-04.jpg",
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "piano-01.jpg",
              "piano-02.jpg",
              "piano-03.jpg",
              "piano-04.jpg",
              "piano-05.jpg"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "cigar-01.jpg",
              "cigar-02.jpg",
              "cigar-03.jpg",
              "cigar-04.jpg",
              "cigar-05.jpg",
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "habitacion-1.jpg",
              "habitacion-2.jpg",
              "habitacion-3.jpg",
              "habitacion-4.png",
              "habitacion-5.png"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "hallway-1.jpg",
              "hallway-2.jpg",
              "hallway-3.jpg"
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "hotel-room-design-01.jpg",
              "hotel-room-design-02.jpg",
              "hotel-room-design-03.jpg",
              "hotel-room-design-04.jpg",
              "hotel-room-design-05.jpg",
              "hotel-room-design-06.jpg",
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "outdoor-restaurant-01.png",
              "outdoor-restaurant-02.jpg",
              "outdoor-restaurant-03.jpg",
              "outdoor-restaurant-04.jpg",
              "outdoor-restaurant-05.jpg",
              "outdoor-restaurant-06.jpg",
              "outdoor-restaurant-07.jpg",
              "outdoor-restaurant-08.jpg",
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "outdoor-design-01.png",
              "outdoor-design-02.jpg",
              "outdoor-design-03.jpg",
              "outdoor-design-04.jpg",
              "outdoor-design-05.jpg",
            ],
            color: "#c679b4",
            icon: "bi bi-lamp-fill"
          },
          {
            thumbnails: [
              "market-1.jpg",
              "market-2.jpg",
              "market-3.jpg",
              "market-4.jpg",
              "market-5.jpg",
              "market-6.jpg",
              "market-7.jpg"
            ],
            color: "#00b6d3",
            icon: "bi bi-pencil-fill"
          },
          {
            thumbnails: [
              "draw-1.jpg",
              "draw-2.jpg",
              "draw-3.jpg",
              "draw-4.jpg",
              "draw-5.jpg",
            ],
            color: "#6165c2",
            icon: "bi bi-rulers"
          },
          {
            thumbnails: [
              "logo-01.jpg",
              "logo-02.jpg",
              "logo-03.png",
              "logo-04.jpg",
            ],
            color: "#ff5349",
            icon: "bi bi-brush-fill"
          },
        ],
      }),
    },
  },
  components: {
    Title,
    VueTimelineUpdate
  },
  setup(props) {
    const { t } = useI18n();

    // Combine static meta (from props) with i18n strings
    const translatedProjects = computed(() =>
      props.content.items.map((meta, idx) => ({
        ...meta,
        title: t(`projects.${idx}.title`),
        content: t(`projects.${idx}.content`),
        tag: t(`projects.${idx}.tag`)
      }))
    );

    return {
      translatedProjects
    }
  },
  methods: {
    getImgUrl(img) {
      if(img == undefined || img == "")
        return ""
      return require('../assets/img/projects/'+img)
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/constants.scss";

$linear: map-get($colors, dark);

#projects {
  background-color: lighten(map-get($colors, primary), 5%);

}

.title {
  color: map-get($colors, light);
}

/deep/ .text-wrapper {
  &:after {
    border-bottom: 1px solid map-get($colors, dark);
  }
}

article .inner {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    z-index: 1;
}

.content {
    color: map-get($colors, light);
    margin-top: 30px;
    header {
        height: 100%;
        width: 70%;
    }
    h1{
        font-size: 3rem;
    }
}

.vertical-center {
    display: flex;
    align-items: center;
}

h1 {
    margin-top: 10px;
    margin-bottom: 20px;
}
</style>
